import { render } from "./InsertParts.vue?vue&type=template&id=dbb8edb0&scoped=true"
import script from "./InsertParts.vue?vue&type=script&lang=js"
export * from "./InsertParts.vue?vue&type=script&lang=js"

import "./InsertParts.vue?vue&type=style&index=0&id=dbb8edb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb8edb0"]])

export default __exports__